import * as React from 'react'

interface StrongColoredTextProps {
	size?: number
	style?: Record<string, string>
}

const StrongColoredText: React.SFC<StrongColoredTextProps> = (props) => {
	const style = {
		fontSize: props.size ? `${props.size}px` : '16px',
		...props.style,
	}

	return (
		<strong style={style} className="text-primary">
			{props.children}
		</strong>
	)
}

export default StrongColoredText
